/* global window */
import store from '../../store';
import { availableA2HChrome, availableA2HChat, availableA2HAd, isFirstMessageSend, isFirstAd, promptOrigin } from 'Actions/addToHome';
import cookieManagerHelper from 'Helpers/cookies';
import { DEFAULT } from 'Constants/addToHome';

let deferredPrompt;
let track;

function getA2HCookies() {
    store.dispatch(isFirstMessageSend(false));
    store.dispatch(isFirstAd(false));
    const cookieA2HChat = cookieManagerHelper.readCookie('A2HChat');
    const cookieA2HAd = cookieManagerHelper.readCookie('A2HAd');

    if (cookieA2HChat && cookieA2HChat !== 'undefined' && typeof cookieA2HChat !== 'undefined') {
        store.dispatch(availableA2HChat(false));
    }
    else {
        store.dispatch(availableA2HChat(true));
    }

    if (cookieA2HAd && cookieA2HAd !== 'undefined' && typeof cookieA2HAd !== 'undefined') {
        store.dispatch(availableA2HAd(false));
    }
    else {
        store.dispatch(availableA2HAd(true));
    }
}

function setA2HCookie(name) {
    const expirationDays = 60;

    cookieManagerHelper.createCookie(name, true, expirationDays);
}

function beforeInstallPrompt(tracking) {
    track = tracking;
    window.addEventListener('beforeinstallprompt', e => {
        e.preventDefault();
        deferredPrompt = e;
        store.dispatch(availableA2HChrome(true));
        store.dispatch(promptOrigin(null));
    });
}

function appInstalled() {
    window.addEventListener('appinstalled', e => {
        deferredPrompt = e;
        store.dispatch(availableA2HChrome(false));
        if (store.getState().addToHome.promptOrigin === null) {
            track('add_to_home_popup', DEFAULT);
            track('add_to_home_accept', DEFAULT);
        }
        store.dispatch(promptOrigin(null));
    });
}

function prompt(originConstant) {
    const originPrompt = { origin: originConstant };

    store.dispatch(promptOrigin(originConstant));
    if (deferredPrompt !== undefined) {
        // The user has had a positive interaction with our app and Chrome
        // has tried to prompt previously, so let's show the prompt.
        deferredPrompt.prompt();

        // Follow what the user has done with the prompt.
        deferredPrompt.userChoice.then(choiceResult => {
            track('add_to_home_popup', originPrompt);

            if (choiceResult.outcome === 'dismissed') {
                track('add_to_home_decline', originPrompt);
                store.dispatch(promptOrigin(null));
            }
            else {
                // We no longer need the prompt.  Clear it up.
                track('add_to_home_accept', originPrompt);
                deferredPrompt = null;
                store.dispatch(availableA2HChrome(false));
            }
        });
    }
}

export {
    getA2HCookies,
    setA2HCookie,
    beforeInstallPrompt,
    appInstalled,
    prompt
};
